export enum CartCookieType {
    LOCAL = 'cart-id',
    ADMIN = 'admin-cart-id',
    EDIT_ORDER = 'edit-cart-id'
}